export enum INTERNAL_EVENTS {
    FsTriggerRendering = 'FS_TRIGGER_RENDERING'
}
